// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__QRpl_","text":"Footer_text__hMZIT","pages":"Footer_pages__17wNH","half":"Footer_half__3rdMF"};